import styled from 'styled-components';
import Button from 'components/Button';
import CloseIcon from 'components/CloseIcon';

export const DetailItemContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    background: linear-gradient(210.55deg, #353A40 -3.02%, #121416 93.08%);
    box-shadow: 36px 12px 64px rgba(2, 3, 3, 0.7), -12px -20px 56px rgba(232, 237, 243, 0.05), inset -16px -6px 80px rgba(248, 249, 249, 0.03);
    padding: 10px;
    padding-bottom: 50px;
    border-radius: 10px;
    margin-top: 10px;
    margin-bottom: 50px;
    
    @media only screen and (min-width: 767px) {
        overflow-x: hidden;
    }
    @media only screen and (max-width: 767px) {
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        background: none;
        box-shadow: none;
        padding: 0px;
    }
`;

export const ContainerCallsToAction = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: space-between;
    justify-content: space-between;
    margin-bottom: 30px;
    margin-top: 20px;
    @media only screen and (max-width: 768px) {
        flex-direction: column;
    }

`;

export const Title = styled.div`
    font-family: Khula;
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    line-height: 100%;
    display: flex;
    align-items: center;
    margin-top: 20px;
    letter-spacing: 0.02em;
    color: #D6E1EF;
`;

export const Image = styled.div`
    width: 120%;
    margin: 15px 0px;
    margin-left: -10%;
    height: 200px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url(${({ src }) => src});
`;

export const Price = styled.div`
    font-family: Khula;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 100%;
    display: flex;
    align-items: center;
    text-align: right;
    color: #D6E1EF;
    margin-top: 20px;
`;

export const Text = styled.div`
    font-family: Khula;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 130%;
    display: flex;
    align-items: center;
    letter-spacing: 0.02em;
    font-feature-settings: 'ordn' on, 'cpsp' on;
    color: #D6E1EF;
    text-shadow: -1px -1px 2px rgba(255, 255, 255, 0.1), 1px 1px 3px #1E2226;
    margin-top: 5px;
`;

export const Subtitle = styled.div`
    font-family: Khula;
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 100%;
    display: flex;
    align-items: center;
    letter-spacing: 0.02em;
    color: #D6E1EF;
    margin-top: 20px;

`;

export const Divider = styled.div`
    width: 100%;
    height: 1px;
    margin: 20px 0px;
    background-color: #FFFFFF;
    opacity: 0.4;
`;

export const ContainerSum = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
    width: 100%;
    flex-shrink: 1;
`;


export const ActionBellowImage = styled(Button)`
    outline: none;
    &:focus{
        outline: none;
    }
    margin-left: 0;
    margin-right: 0;
    width: 48%;
    height: 40px;
    border-radius: 400px;
    border: none;
    font-family: Khula;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 100%;
    display: flex;
    align-items: center;
    text-align: center;
    color: #D6E1EF;
    opacity: 0.95;
    position: relative;
    &>svg{
        position: absolute;
        right: 15px;
        height: 25px;
        top: 7px;
        opacity: 0.9;
    }
    &:hover{
        opacity: 1;
        &>svg{
            opacity: 1;
        }
    }
    @media only screen and (max-width: 768px) {
        margin-top: 5px;
        width: 100%;
        flex-shrink: 0;
        margin-top: 10px;
    }
`;

export const CallToAction = styled(Button)`
    width: 50%;
    height: 40px;
    border-radius: 400px;
    font-family: Khula;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 100%;
    display: flex;
    align-items: center;
    text-align: center;
    color: #D6E1EF;
    opacity: 0.90;
    margin-left: auto;
    position: relative;
    outline: none;
    &:focus{
        outline: none;
    }
    &:hover{
        opacity: 1;
        &>svg{
            opacity: 1;
        }
    }
    &>svg{
        position: absolute;
        right: 15px;
        height: 25px;
        top: 7px;
        opacity: 0.90;
    }
    @media only screen and (max-width: 768px) {
        margin-top: 5px;
        width: 100%;
        flex-shrink: 0;
        margin-top: 10px;
    }
`;

export const ContainerDeliveryTime = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    font-family: Khula;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 100%;
    /* identical to box height, or 18px */
    display: flex;
    align-items: center;
    color: #D6E1EF;
    opacity: 0.8;
    margin-right: 40px;
`;


export const ContainerPrice = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    font-family: Khula;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 100%;
    /* identical to box height, or 18px */

    display: flex;
    align-items: center;

    color: #D6E1EF;

    opacity: 0.8;
    @media only screen and (max-width: 768px) {
        margin-left: auto;
        text-align: right;
        margin-right: 0px;

    }
`;

export const CloseButton = styled(CloseIcon)`

`;

export const CloseButtonContainer = styled.div`
    position: absolute !important;
    text-align: right;
    right: 10px;
    top: 10px;
    cursor: pointer;
    opacity: 0.7;
    &:hover{
        opacity: 1;
    }
`;